export const appConfig = {
  IDB: {
    NAME: 'companion-db',
    VERSION: 1,
    STORE: {
      MIS_SUMMARY: 'mis-summary',
      MIS_METADATA: 'mis-metadata',
      MIS_COMPLIANCE: 'mis-compliance',
      INVOICE_SUMMARY: 'invoice-summary'
    },
  },
  INVOICE_SUMMARY_PAGE_SIZE: 10,
  INVOICE_PDF_TEMPLATE_ID: '179471da-fcc9-4a1e-bf17-33b57c5f445c',
  HEADER_CALLER: 'eInv-Companion'
};
